<template>
  <a
      class="font-body outline-none rounded-5 transition-all duration-200 cursor-pointer select-none text-center no-underline inline-block"
      :class="[sizeClass, variantClass]"
      v-bind="$attrs"
      :href="href"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: 'BaseLink',
  props: {
    href: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      required: false,
      default: 'primary',
    },
    size: {
      type: String,
      required: false,
      default: 'inline',
    },
  },
  computed: {
    sizeClass() {
      return {
        inline: '',
        small: 'size-small',
        large: 'size-large',
      }[this.size];
    },
    variantClass() {
      return {
        primary: 'variant-primary',
        secondary: 'variant-secondary',
        tertiary: 'variant-tertiary',
        invisible: 'variant-invisible',
      }[this.variant];
    },
  },
};
</script>

<style scoped>

.variant-primary {
  @apply border-none bg-primaryGradient text-whiteOverride
}
.variant-secondary {
  @apply bg-whiteOverride text-dark3 border-solid border-1 border-disabledGrey
}
.variant-tertiary {
  @apply bg-whiteOverride text-dark3 border-solid border-1 border-disabledGrey
}
.variant-invisible {
  @apply border-none bg-transparent underline
}
.variant-primary {
  @apply hover:bg-primaryHover hover:drop-shadow-button active:bg-primaryGradient active:drop-shadow-none
}
.variant-secondary {
  @apply hover:drop-shadow-buttonLight hover:bg-secondaryHover hover:text-whiteOverride hover:border-secondaryHover active:border-disabledGrey active:text-dark3 active:bg-whiteOverride active:drop-shadow-none
}
.variant-tertiary {
  @apply hover:drop-shadow-button hover:bg-offWhite active:drop-shadow-none active:bg-whiteOverride
}
.variant-invisible {
  @apply hover:text-primaryGradient focus:text-primaryGradient active:text-primaryGradient visited:text-inherit
}
.size-small {
  @apply text-12 px-twenty py-sm font-normal
}
.size-large {
  @apply px-lButtonXPadding py-lButtonYPadding text-16 font-medium
}
</style>
